import { render, staticRenderFns } from "./SelectFormatForm.vue?vue&type=template&id=6ff25d08&"
import script from "./SelectFormatForm.vue?vue&type=script&lang=ts&"
export * from "./SelectFormatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports